import { render, staticRenderFns } from "./incidence.vue?vue&type=template&id=31ab152c&scoped=true"
import script from "./incidence.vue?vue&type=script&lang=js"
export * from "./incidence.vue?vue&type=script&lang=js"
import style0 from "./incidence.vue?vue&type=style&index=0&id=31ab152c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ab152c",
  null
  
)

export default component.exports